import {
  GetComplianceInvestigationActionOrInstructionDetailsAsync,
  IComplianceInvestigationActionOrInstructionDetails,
} from "./ComplianceInvestigation/IComplianceInvestigationActionsAndInstructions";
import { API_URL } from "./Config";
import { formatDate } from "./DateUtils";
import {
  GetComplianceInvestigationDetailsAsync,
  IComplianceInvestigationDetails,
} from "./IComplianceInvestigation";
import {
  GetEpaCorrespondenceDetailsAsync,
  IEpaCorrespondenceDetails,
} from "./IEpaCorrespondence";
import {
  GetFindingAndRecommendationDetailsAsync,
  IFindingAndRecommendationDetails,
} from "./IFindingAndRecommendation";
import {
  GetLicenseeReturnDetailsAsync,
  ILicenseeReturn,
  ILicenseeReturnDetails,
} from "./ILicenseeReturns";
import { GetSiteVisitDetailsAsync, ISiteVisitDetails } from "./ISiteVisit";
import { GetTaskDetailsAsync, isFindingOrRecommentation } from "./ITask";
import {
  GetThirdPartyCorrespondenceDetailsAsync,
  IThirdPartyCorrespondenceDetails,
} from "./IThirdPartyCorrespondence";

//https://data-int.epa.ie/leap/api/v1/EdenMessage/listbytaskid?task_id=D984E9E7-8AC0-EC11-A341-0050568A2D1A&page=1&per_page=50

export interface IEdenMessage {
  edenmessageid: string;
  type: string;
  licenceid: string;
  reference: string;
  status: string;
  dateraised: string;
  closeddate: string;
  subject: string;
  message: string;
  response: string;
  regardingobjectid: string;
  taskid: string;
}

export interface IEdenMessageDetails {
  edenmessageid: string;
  type: string;
  licenceid: string;
  reference: string;
  status: string;
  dateraised: string;
  closeddate: string;
  subject: string;
  message: string;
  response: string;
  regardingobjectid: string;
  taskid: string;
  siteVisit?: ISiteVisitDetails;
  findingAndRecommendation?: IFindingAndRecommendationDetails;
  licenseeReturn?: ILicenseeReturnDetails;
  actionOrInstructionDetails?: IComplianceInvestigationActionOrInstructionDetails;
  complianceInvestigationDetails?: IComplianceInvestigationDetails;
  epaCorrespondenceDetails?: IEpaCorrespondenceDetails;
}

export const GetEdenMessagesByTaskFetchUrl = (
  taskId: string,
  pageNo: number,
  recordsPerPage: number,
  searchText: string,
  filters: any
) => {
  let params = `&page=${pageNo}&per_page=${recordsPerPage}`;

  if (searchText.length > 0) {
    params += `&search_term=${encodeURIComponent(searchText)}`;
  }
  let url = `${API_URL}/EdenMessage/listbytaskid?task_id=${taskId}${params}`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/edenmessages-bytaskid`;
  }

  return url;
};

export const GetEdenMessagesByRegardingFetchUrl = (
  regardingObjectId: string,
  pageNo: number,
  recordsPerPage: number,
  searchText: string,
  filters: any
) => {
  let params = `&page=${pageNo}&per_page=${recordsPerPage}`;

  if (searchText.length > 0) {
    params += `&search_term=${encodeURIComponent(searchText)}`;
  }
  let url = `${API_URL}/EdenMessage/listbyregardingid?regarding_id=${regardingObjectId}${params}`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/edenmessages-byregardingid`;
  }

  return url;
};

export async function GetEdenMessageDetailsAsync(
  edenMessageId: string
): Promise<IEdenMessageDetails> {
  var url = `${API_URL}/EdenMessage/byid?eden_message_id=${edenMessageId}`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/edenmessage-details`;
  }

  const response = await fetch(url);
  const body = <IEdenMessageDetails>await response.json();

  let isSiteVisit = false;
  let isComplianceInvestigation = false;

  if (body.taskid) {
    const taskDetails = await GetTaskDetailsAsync(body.taskid);
    if (isFindingOrRecommentation(taskDetails.type)) {
      isSiteVisit = true;
      body.findingAndRecommendation =
        await GetFindingAndRecommendationDetailsAsync(body.taskid);
    } else {
      isComplianceInvestigation = true;
      body.actionOrInstructionDetails =
        await GetComplianceInvestigationActionOrInstructionDetailsAsync(
          body.taskid
        );
    }
  }

  if (body.regardingobjectid) {
    if (isSiteVisit) {
      body.siteVisit = await GetSiteVisitDetailsAsync(body.regardingobjectid);
    } else if (isComplianceInvestigation) {
      body.complianceInvestigationDetails =
        await GetComplianceInvestigationDetailsAsync(body.regardingobjectid);
    } else {
      body.epaCorrespondenceDetails = await GetEpaCorrespondenceDetailsAsync(
        body.regardingobjectid
      );

      const lr = await GetLicenseeReturnDetailsAsync(body.regardingobjectid);

      if (lr.response.ok) {
        body.licenseeReturn = lr;
      }
    }
  }

  return <IEdenMessageDetails>{
    edenmessageid: body.edenmessageid,
    type: body.type,
    licenceid: body.licenceid,
    reference: body.reference,
    status: body.status,
    dateraised: formatDate(body.dateraised),
    closeddate: formatDate(body.closeddate),
    message: body.message,
    subject: body.subject,
    response: body.response,
    regardingobjectid: body.regardingobjectid,
    taskid: body.taskid,
    siteVisit: body.siteVisit,
    findingAndRecommendation: body.findingAndRecommendation,
    complianceInvestigationDetails: body.complianceInvestigationDetails,
    licenseeReturn: body.licenseeReturn,
    actionOrInstructionDetails: body.actionOrInstructionDetails,
    epaCorrespondenceDetails: body.epaCorrespondenceDetails,
  };
}
